'use strict';

var keyMirror = require('keymirror');

module.exports = {
	ActionTypes: keyMirror({
		NEWS_SEARCH_LOAD_DATA: null,
		NEWS_SEARCH_LOAD_DATA_SUCCESS: null,
		NEWS_SEARCH_LOAD_DATA_ERROR: null,
		NEWS_SEARCH_UPDATE_FILTERS: null,
		NEWS_SEARCH_SUBMIT_FORM: null,
		NEWS_SEARCH_CLEAR_FILTERS: null
	})
};